export interface ODataResult<T>
{
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "@odata.context"?: number;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    "@odata.count"?: number;
    value: T[];
}

export function isODataResult<T>(obj: unknown): obj is ODataResult<T>
{
    return obj
        && typeof obj === "object"
        && ("@odata.context" in obj
            || "@odata.count" in obj)
        && "value" in obj;
}
